module.exports = __webpack_public_path__ + "src/assets/img/car_diagnostics.26304da3.jpg";